module.exports = __webpack_public_path__ + "static/media/166.d5fcb436.jpg";